import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {MarketTableModel} from "./market-table-class.model";
import {DataService} from "../../services/data.service";
import {HttpErrorResponse} from "@angular/common/http";
import {UtilService} from "../../services/util.service";

@Component({
  selector: 'app-market-table',
  templateUrl: './market-table.component.html',
  styleUrls: ['./market-table.component.scss']
})
export class MarketTableComponent implements OnInit {
  @Input() marketType: string;
  @Input() title: string;
  @Output() dataEmit = new EventEmitter();
  marketData: MarketTableModel[] = [];
  powerColumnDefs = [
    // {
    //   label: "Observation Date",
    //   field: "observationDate"
    // },
    {
      label: "Market",
      field: "market"
    },{
      label: "Hub",
      field: "node"
    },{
      label: "Start Date",
      field: "prevailingStartDate"
    },{
      label: "Prompt % Change",
      field: "pctChange"
    },{
      label: "6M % Change",
      field: "pctChange6M"
    },{
      label: "12M % Change",
      field: "pctChange12M"
    },{
      label: "24M % Change",
      field: "pctChange24M"
    },
  ];
  gasColumnDefs = [
    // {
    //   label: "Observation Date",
    //   field: "observationDate"
    // },
    {
      label: "Location",
      field: "location"
    },{
      label: "Product",
      field: "product"
    },{
      label: "Start Date",
      field: "prevailingStartDate"
    },{
      label: "Current Price",
      field: "currentPrice"
    },
    // {
    //   label: "Previous Price",
    //   field: "prevPrice"
    // },
    {
      label: "Prompt % Change",
      field: "pctChange"
    }
  ];
  columnDefs: any = [];

  constructor(private dataService: DataService, private  utilService: UtilService) { }

  ngOnInit(): void {
    this.columnDefs = this.marketType == 'gas' ? this.gasColumnDefs: this.powerColumnDefs;
    this.dataService.getMarketData(this.marketType == 'gas' ? 'natgas': 'power').subscribe(res => {
     // if(res && res.length) {
       this.marketData = res as MarketTableModel[];
       // if(this.marketType == 'power'){
         this.dataEmit.emit(res[0]['observationDate']);
       // }
     // }
    }, (err: HttpErrorResponse) => {

    })
  }


}
